var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col w-full px-6 mt-5"},[_c('base-button',{staticClass:"w-full",attrs:{"variant":"bordered-error"},on:{"click":_vm.removeEmailBubble}},[_vm._v(" Remove email ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }